<section class="pt-2 ">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
        <h6>{{ isFormView ? 'Registrar detalle de solución' : 'Detalle de solución' }}</h6>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex justify-content-end gap-2">
        <app-custom-button [title]="'Importar Detalles'" [icon]="'pi pi-file-import'" [severity]="'primary'"
          [disabled]="disabledButton" (onClick)="openImportDetailModal()"></app-custom-button>
        <app-custom-modal #importDetailModal [label]="'Importar Detalles'" [width]="'40rem'"
          [header]="'Importar Detalles'" [children]="componentImportDetailModal"
          [inputs$]="inputsForImportDetailModals$" (params)="reload($event.reload)" hidden></app-custom-modal>
        <app-custom-modal #articleSelection [label]="'Nuevo Detalle'" [header]="'Selección de artículos'"
          [children]="component" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
          (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
        <app-custom-button tom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
          [width]="'6.5rem'" (onClick)="openArticleSelectionModal()">
        </app-custom-button>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-master-solution-detail [masterSolutionDetailContract]="masterSolutionDetail"
          [masterSolutionDetails]="masterSolutionDetails" (updateListDetail)="getMasterSolutionDetailsForCapture()"
          (isFormView)="getFormView($event)">
        </app-register-master-solution-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !disabledButton" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getMasterSolutionDetailsForCapture()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>